import { api } from "../intreceptor/apiInterceptor";

export interface JobsiteLogs {
    id: string;
    userId: string;
    userName: string;
    jobId: string;
    actionType: string;
    entityType: string;
    previousValue: Record<string, any>;
    newValue: Record<string, any>;
    timeStamp: string;
}

export interface JobsiteLogsMetadata {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface JobsiteLogsFilters {
    jobId?: string;
    userId?: string;
    startDate?: string;
    endDate?: string;
    actionType?: ('CREATE' | 'UPDATE' | 'DELETE')[];
    entityType?: string[];
    search?: string;
    page?: number;
    limit?: number;
}

export interface JobsiteLogsResponse {
    data: JobsiteLogs[];
    metadata: JobsiteLogsMetadata;
}

export const LogsService = {
    async getJobsiteLogs(filters: JobsiteLogsFilters = {}): Promise<JobsiteLogsResponse> {
        const params = new URLSearchParams();
        
        // Add filter parameters if they exist
        if (filters.jobId) params.append('jobId', filters.jobId);
        if (filters.userId) params.append('userId', filters.userId);
        if (filters.startDate) params.append('startDate', filters.startDate);
        if (filters.endDate) params.append('endDate', filters.endDate);
        if (filters.actionType && filters.actionType.length > 0) {
            filters.actionType.forEach(type => params.append('actionType', type));
        }
        if (filters.entityType && filters.entityType.length > 0) {
            filters.entityType.forEach(type => params.append('entityType', type));
        }
        if (filters.search) params.append('search', filters.search);
        
        // Add pagination parameters with defaults
        params.append('page', String(filters.page || 1));
        params.append('limit', String(filters.limit || 10));
        
        try {
            return await api.fetch(`/jobsite-logs?${params.toString()}`, {
                method: 'GET'
            });
        } catch (error) {
            console.error('Error fetching jobsite logs:', error);
            // Return empty data set with metadata when API fails
            return {
                data: [],
                metadata: {
                    total: 0,
                    page: filters.page || 1,
                    limit: filters.limit || 10,
                    totalPages: 0,
                    hasNext: false,
                    hasPrevious: false
                }
            };
        }
    }
};
